<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">
        <div class="alert alert-danger" role="alert">
          <b class="fs-4">공휴일(대체휴일 포함) 관리</b>
        </div>
        <div style="display: flex; width:100%;">
          <div style="width: 49%; margin-right: 1%;">
            <table class="table table-bordered table-striped fs-6 align-item-atart text-center">
              <thead class="small">
                <tr>
                  <!-- <th style="width:40px;">
                    <input class="form-check-input" type="checkbox" v-model="allSelected" @change="allChoice()" />
                  </th> -->
                  <!-- <th style="width:10%">seq</th> -->
                  <th style="width:10%">No</th>
                  <th style="width:20%">일자</th>
                  <th style="width:20%">휴일명</th>
                  <th style="width:10%">사용여부</th>
                  <th style="width:10%">기능</th>
                </tr>
              </thead>
              <tbody class="small">
                <tr>
                  <td></td>
                  <td class="form-control-sm text-primary">
                    <input type="date" class="form-control-sm" v-model="dayOff">
                  </td>
                  <td>
                    <input type="text" class="form-control-sm" v-model="doName">
                  </td>
                  <td>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_pUseFlag" v-model="doUseFlag">
                      <option value="Y" class="text-success">Y</option>
                      <option value="N" class="text-danger">N</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-warning btn-sm" style="font-size: small;" @click="createDayOff()">생성</button>
                  </td>
                </tr>
                <tr :key="i" v-for="(m, i) in dayOffList">
                  <!-- <td>{{ m.doSeq }}</td> -->
                  <td>{{ i+1 }}</td>
                  <td class="form-control-sm text-primary">
                    <input type="date" class="form-control-sm" v-model="m.dayOff">
                  </td>
                  <td>
                    <input type="text" class="form-control-sm" v-model="m.doName">
                  </td>
                  <td>
                    <select class="form-select form-select-sm" aria-label=".form-select-sm" ref="sel_pUseFlag" v-model="m.doUseFlag">
                      <option value="Y" class="text-success">Y</option>
                      <option value="N" class="text-danger">N</option>
                    </select>
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm" style="font-size: small;" @click="update_DayOff(m.dayOff, m.doName, m.doUseFlag, m.doSeq)">변경</button>&nbsp;&nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      dayOffList: [],            //휴일리스트

      dayOff:  null,             //휴일일자
      doName: "",                //휴일명
      doUseFlag: "Y",            //휴일사용여부
    };
  },
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;

    this.getDoOffDateList()
  }, 
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    if(document.referrer == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";    
  },
  methods: {
    //memberInfo: 회원정보리스트용 sql
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    // mixins에 있는 공통함수 호출샘플
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },

    async getDoOffDateList() {
      //let dayOffList = []
      let dayOffList_tmp = await this.$api("/api/doOffDateList", {})

      if(dayOffList_tmp.length > 0)
      {
        let i = 0
        let dayOff = ""
        while(i < dayOffList_tmp.length)
        {
          dayOff = this.getDateFormat(dayOffList_tmp[i].doDate)
          dayOffList_tmp[i].dayOff = dayOff

          i++
        }
        this.dayOffList = dayOffList_tmp
      }
      else
      {
        this.$swal.fire('', '휴일정보가 없습니다.', 'warning')
      }
      //console.log("dayOffList:", this.dayOffList)
    },


    async createDayOff(){
      let ins_dayOff = await this.$api("/api/ins_dayOff", {param: [
        this.dayOff, this.doName, this.doUseFlag, this.user.handlerId
      ]})
      //console.log("upd_baseCodeInfo:", upd_baseCodeInfo)
      if(ins_dayOff.affectedRows > 0)
      {
        this.$swal.fire("","공휴일(대체휴일)이 생성되었습니다", "success")
        .then(() => {
          location.reload(true)
        })
      }
    },

    // m.dayOff, m.doName, m.doUseFlag, m.doSeq
    async update_DayOff(dayOff, doName, doUseFlag, doSeq){
      let upd_dayOff = await this.$api("/api/upd_dayOff", {param: [
        dayOff, doName, doUseFlag, this.user.handlerId, doSeq
      ]})
      if(upd_dayOff.affectedRows > 0)
      {
        this.$swal.fire("","변경이 완료되었습니다,", "success")
        .then(() => {
          location.reload(true)
        })
      }
    },
  }
}
</script>